module.exports = __webpack_public_path__ + "img/support-4.17e18dc9.png";